import type React from "react"

export type NavTab = "home" | "explore" | "guide"

interface Props {
  active: NavTab
  onChange: (tab: NavTab) => void
}

const HomeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
)

const MapIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" />
    <line x1="9" y1="3" x2="9" y2="18" />
    <line x1="15" y1="6" x2="15" y2="21" />
  </svg>
)

const BookIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
  </svg>
)

const TABS: { id: NavTab; label: string; Icon: () => React.ReactElement }[] = [
  { id: "home",    label: "Home",    Icon: HomeIcon },
  { id: "explore", label: "Explore", Icon: MapIcon },
  { id: "guide",   label: "Guide",   Icon: BookIcon },
]

export function BottomNav({ active, onChange }: Props) {
  return (
    <nav className="gc-nav" role="tablist" aria-label="Guidebook sections">
      {TABS.map(({ id, label, Icon }) => (
        <button
          key={id}
          role="tab"
          aria-selected={active === id}
          className={`gc-nav__btn${active === id ? " gc-nav__btn--active" : ""}`}
          onClick={() => onChange(id)}
          type="button"
        >
          <span className="gc-nav__icon"><Icon /></span>
          <span className="gc-nav__label">{label}</span>
        </button>
      ))}
    </nav>
  )
}
